import React, { Component } from 'react';
import { TextField } from '@material-ui/core';

/**
 * region for hepers*/
import typing from '../../../helpers/typing';

class SelectContentSearch extends Component {
    state = {
        search: "",
        error: false
    };

    onChange = (e) => {
        this.setState({ search: e.target.value })
    };

    onKeyPress = (e) => {
        if (e.which === 13) {
            if (typing.isEmpty(this.state.search)) {
                this.setState({ error: true })
            } else {
                this.setState({ error: false })
                this.props.onAttributeUpdate(this.state.search)
            }
        }
    };

    render() {
        const { search, error } = this.state;
        return (
            <TextField
                id="outlined-secondary"
                label="Search"
                variant="outlined"
                size="small"
                style={{ marginTop: 8,marginBottom:8 }}
                fullWidth
                error={error}
                value={search}
                onKeyPress={this.onKeyPress}
                onChange={this.onChange}
            />
        )
    }
};
export default SelectContentSearch;